import React, { useEffect, useState } from "react";
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';

import Skeleton from 'react-loading-skeleton'; // Import Skeleton
import whiteArrow from '../assets/images/button-arrow.svg'
import MobileBannerVector from '../assets/images/mobile-banner-icon.svg'

import { useDispatch, useSelector } from "react-redux";
import { clearMessages, getSliders } from "../features/visitor/visitorActions";
import { toast } from "react-toastify"; // Import toast

function Banner() {
  
  // State to store all fetched sliders
  const [allSliders, setAllSliders] = useState([]);

  const dispatch = useDispatch();
  const { errorMessage, sliderResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    let data = { page: 1, limit: 20 };
    dispatch(getSliders(data));
  }, [dispatch]);

  useEffect(() => {
    if (sliderResponse?.data) {
      const filteredSliders = sliderResponse.data.filter(slider => slider.type === 1);
      setAllSliders(filteredSliders);
    }
  }, [sliderResponse]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  if (!sliderResponse) {
    // Render the skeleton when loading
    return (
      <section className='home-banner'>
        <Swiper
 modules={[Pagination, Autoplay]}
        slidesPerView={1.2}
        centeredSlides={true}
        spaceBetween={8}
        loop={true}
        infinite={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
            loop: false,
            autoplay: false,
          }
        }}
        >
          {Array(3).fill(0).map((_, index) => (
            <SwiperSlide key={index}>
              <Skeleton height="95vh" />
              <div className="banner-content-wrap">
                <Skeleton width={200} height={30} />
                <Skeleton width={300} height={20} />
                <Skeleton width={250} height={20} />
                <Skeleton width={150} height={40} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    );
  }

  return (
    <section className='home-banner'>          
     <Swiper
         modules={[Pagination, Autoplay]}
        slidesPerView={1.2}
        centeredSlides={true}
        spaceBetween={8}
        loop={true}
        infinite={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
            loop: false,
            autoplay: false,
          }
        }}
      >
        {allSliders.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <img className='w-100' src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${slide.image}`} alt="" />
            <div className="banner-content-wrap">
                <div dangerouslySetInnerHTML={{__html: slide?.first_line}}></div>
                <div dangerouslySetInnerHTML={{__html: slide?.second_line}}></div>
                <div dangerouslySetInnerHTML={{__html: slide?.third_line}}></div>
                
                <div className="promo-code-wrap">
                  <div className="promo-code">
                    <p>Promocode</p>
                    <h3>{slide?.promocode}</h3>
                  </div>
                  <h2>{slide?.promo_code_title}</h2>
                </div>
                <Link to={slide?.button_url} className='cutsom-bttn'>{slide?.button_label} <img src={whiteArrow} alt="" /></Link>
            </div>
          </SwiperSlide> 
        ))}  
      </Swiper>
    </section>
  )
}
export default Banner